import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonInput } from '@ionic/angular';

import { QRCodeService } from '../../../global/qr-code-service';

@Component({
    standalone: false,
    selector: 'abs-import-force',
    template: `
        <div [class]="cssClass">
            <form (submit)="redirectToSharedForce()" class="form">
                <p>{{ 'GLOBAL.SHARE.IMPORT.DESCRIPTION' | translate }}</p>
                <div *ngIf="enableQRCode">
                    <ion-button (click)="importByQRCode()">{{ 'GLOBAL.SHARE.QR_CODE.IMPORT' | translate }}</ion-button>
                </div>
                <div class="form-row form-row-inline">
                    <ion-input #importCode className="alert-input-wrapper sc-ion-alert-md"></ion-input>
                    <ion-button class="btn-icon form-item-append" (click)="redirectToSharedForce()"
                        ><ion-icon name="cloud-download-outline"></ion-icon
                    ></ion-button>
                </div>
                <p class="error" *ngIf="importError">
                    {{ 'GLOBAL.SHARE.IMPORT.ERRORS.INVALID_CODE' | translate }}
                </p>
            </form>
        </div>
    `,
    styles: [
        `
            ion-button.btn-icon {
                flex: 0 0 auto;
            }

            .form-row {
                display: flex;
            }
        `
    ]
})
export class ImportForceComponent {
    @Input()
    cssClass: string;

    @Input()
    redirectPrefix: string[] = [];

    @Input()
    enableQRCode: boolean;

    @ViewChild('importCode')
    importCode: IonInput;

    importError = false;

    @Output()
    redirect = new EventEmitter<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private qrService: QRCodeService
    ) {}

    redirectToSharedForce() {
        try {
            this.importError = false;
            const code = '' + this.importCode.value;
            const forceId = parseInt(code, 36);
            if (isNaN(forceId) || !/^[A-Za-z0-9]{8,10}$/.test(code)) {
                throw new Error('Invalid code: ' + code);
            }
            this.redirect.emit();
            this.router.navigate([...this.redirectPrefix, forceId], { relativeTo: this.route });
        } catch (err) {
            console.error(err);
            this.importError = true;
        }
    }

    importByQRCode() {
        this.qrService.scan().subscribe((res) => {
            console.log({ res });
        });
    }
}
